"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = require("../../utils/styles/index");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- EXPORT : ACCORDION : STYLES --------------- ++++++++++ */


var _default = {
  accordion: {
    marginTop: (0, _index.pxToEm)(15),
    '& .title': {
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      background: '#fff',
      border: (0, _index.replacePXinStringWithEM)('1px solid #ddd'),
      borderRadius: (0, _index.pxToEm)(25),
      padding: (0, _index.replacePXinStringWithEM)('10px 20px 10px 10px'),
      position: 'relative',
      zIndex: '2',
      '& .hotspot': {
        width: '100%',
        height: '100%',
        position: 'absolute',
        top: '0',
        left: '0',
        zIndex: '1'
      },
      '& .iconography': {
        background: _index.theme.color.primary.medium.swatch,
        color: '#fff',
        border: (0, _index.replacePXinStringWithEM)('1px solid #ddd'),
        borderRadius: '100%',
        height: (0, _index.pxToEm)(35),
        width: (0, _index.pxToEm)(40),
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      },
      '& .text': {
        marginRight: (0, _index.pxToEm)(15),
        marginLeft: (0, _index.pxToEm)(15),
        width: '100%',
        display: 'block',
        extend: (0, _index.coloredScrollBar)('transparent'),
        overflow: function overflow(props) {
          return props.nowrap ? 'auto' : 'visible';
        },
        whiteSpace: function whiteSpace(props) {
          return props.nowrap ? 'nowrap' : 'normal';
        },
        '& .textinner': {
          fontSize: (0, _index.pxToEm)(18),
          fontWeight: '600',
          display: 'inline-block',
          position: 'relative',
          zIndex: '2'
        }
      },
      '& .indicator': {
        fontSize: '135%',
        color: _index.theme.color.primary.medium.swatch
      }
    },
    '& .contents': {
      overflow: 'hidden',
      height: 'auto',
      maxHeight: '0',
      transition: 'all .15s ease-out 0s',
      opacity: '0',
      background: '#fafafa',
      border: (0, _index.replacePXinStringWithEM)('1px solid #ddd'),
      borderRadius: (0, _index.replacePXinStringWithEM)('0 0 20px 20px'),
      padding: (0, _index.replacePXinStringWithEM)('45px 30px 30px'),
      marginTop: (0, _index.pxToEm)(-20),
      position: 'absolute',
      zIndex: '-1'
    },
    '&.isActive-true': {
      '& .contents': {
        maxHeight: (0, _index.pxToEm)(600),
        // still have to hard-code a value!
        position: 'relative',
        opacity: '1',
        zIndex: '1'
      }
    }
  }
};
exports.default = _default;